/* eslint-disable */
export const carBarangays = [
    {
        CITY: 'DOLORES',
        BARANGAY: 'BAYAAN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'CABAROAN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'CALUMBAYA',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'CARDONA',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'ISIT',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'KIMMALABA',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'LIBTEC',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'LUB-LUBBA',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'MUDIIT',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'NAMIT-INGAN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'PACAC',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'SALUCAG',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'TALOGTOG',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'TAPING',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'BENBEN (BONBON)',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'BULBULALA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'BULI',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'CANAN (GAPAN)',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'LIGUIS',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'MALABBAGA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'MUDENG',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'PIDIPID',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'TOON',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'UDANGAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BOLBOLO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BROOKSIDE',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DALIT',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DINTAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'GAPANG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'KINABITI',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'MALIPLIPIT',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'NAGCANASAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'NANANGDUAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'NARNARA',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'OCUP',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PANG-OT',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PATAD',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN-JUAN EAST',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN-JUAN WEST',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SOUTH BALIOAG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'TIKITIK',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'VILLAVIEJA',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CABAYOGAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'DALIMAG',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'LANGBABAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'MANAYDAY',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'PANTOC',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SABTAN-OLO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SAN MARCIAL',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'TANGBAO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'ABUALAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BADAS',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BA-UG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CABCABORAO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'COLABAOAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CULIONG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'DAOIDAO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'GUIMBA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'LAM-AG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'LUMOBANG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'NANGOBONGAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PATTAOIG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'QUIDAOEN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SABANGAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SILET',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SUPI-IL',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TAGAYTAY',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'LABAAN',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'PALANG',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'PANTOC',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'TANGADAN',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'VILLA MERCEDES',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'AGTANGAO',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'ANGAD',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'BAGACAO',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'BANACAO',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'BANGBANGAR',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'CABULOAN',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'CALABA',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'COSILI EAST (PROPER)',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'COSILI WEST (BUAYA)',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'DANGDANGLA',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'LINGTAN',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'LIPCAN',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'LUBONG',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'MACARCARMAY',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'MACRAY',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'MALITA',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'MAOAY',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'PALAO',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'PATUCANNAY',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'SAGAP',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'SAO-ATAN',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'SAPPAAC',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'TABLAC (CALOT)',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'ZONE 1 POB. (NALASIN)',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'ZONE 2 POB. (CONSILIMAN)',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'ZONE 3 POB. (LALAUD)',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'ZONE 4 POB. (TOWN PROPER)',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'ZONE 5 POB. (BO. BARIKIR)',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'ZONE 6 POB. (SINAPANGAN)',
    },
    {
        CITY: 'BANGUED',
        BARANGAY: 'ZONE 7 POB. (BALILING)',
    },
    {
        CITY: 'BOLINEY',
        BARANGAY: 'AMTI',
    },
    {
        CITY: 'BOLINEY',
        BARANGAY: 'BAO-YAN',
    },
    {
        CITY: 'BOLINEY',
        BARANGAY: 'BOLINEY POBLACION',
    },
    {
        CITY: 'BOLINEY',
        BARANGAY: 'DANAC EAST',
    },
    {
        CITY: 'BOLINEY',
        BARANGAY: 'DANAC WEST',
    },
    {
        CITY: 'BOLINEY',
        BARANGAY: 'DAO-ANGAN',
    },
    {
        CITY: 'BOLINEY',
        BARANGAY: 'DUMAGAS',
    },
    {
        CITY: 'BOLINEY',
        BARANGAY: 'KILONG-OLAO',
    },
    {
        CITY: 'BOLINEY',
        BARANGAY: 'POBLACION (BOLINEY)',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'ABANG',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'BANGBANGCAG',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'BANGCAGAN',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'BANGLOLAO',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'BUGBOG',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'CALAO',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'DUGONG',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'LABON',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'LAYUGAN',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'MADALIPAY',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'PAGALA',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'PAKILING',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'PALAQUIO',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'PATOC',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'QUIMLOONG',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'SALNEC',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'SIBLONG',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'BUCAY',
        BARANGAY: 'TABIOG',
    },
    {
        CITY: 'BUCLOC',
        BARANGAY: 'DUCLIGAN',
    },
    {
        CITY: 'BUCLOC',
        BARANGAY: 'LABAAN',
    },
    {
        CITY: 'BUCLOC',
        BARANGAY: 'LAMAO',
    },
    {
        CITY: 'BUCLOC',
        BARANGAY: 'LAMAO (POB.)',
    },
    {
        CITY: 'BUCLOC',
        BARANGAY: 'LINGAY',
    },
    {
        CITY: 'DAGUIOMAN',
        BARANGAY: 'ABLEG',
    },
    {
        CITY: 'DAGUIOMAN',
        BARANGAY: 'CABARUYAN',
    },
    {
        CITY: 'DAGUIOMAN',
        BARANGAY: 'PIKEK',
    },
    {
        CITY: 'DAGUIOMAN',
        BARANGAY: 'TUI',
    },
    {
        CITY: 'DAGUIOMAN',
        BARANGAY: 'TUI (POB.)',
    },
    {
        CITY: 'DANGLAS',
        BARANGAY: 'ABAQUID',
    },
    {
        CITY: 'DANGLAS',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'DANGLAS',
        BARANGAY: 'CAUPASAN',
    },
    {
        CITY: 'DANGLAS',
        BARANGAY: 'CAUPASAN (POB.)',
    },
    {
        CITY: 'DANGLAS',
        BARANGAY: 'DANGLAS',
    },
    {
        CITY: 'DANGLAS',
        BARANGAY: 'NAGAPARAN',
    },
    {
        CITY: 'DANGLAS',
        BARANGAY: 'PADANGITAN',
    },
    {
        CITY: 'DANGLAS',
        BARANGAY: 'PANGAL',
    },
    {
        CITY: 'LACUB',
        BARANGAY: 'BACAG',
    },
    {
        CITY: 'LACUB',
        BARANGAY: 'BUNEG',
    },
    {
        CITY: 'LACUB',
        BARANGAY: 'GUINGUINABANG',
    },
    {
        CITY: 'LACUB',
        BARANGAY: 'LAN-AG',
    },
    {
        CITY: 'LACUB',
        BARANGAY: 'PACOC',
    },
    {
        CITY: 'LACUB',
        BARANGAY: 'POBLACION (TALAMPAC)',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'AGUET',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'BACOOC',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'BALAIS',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'CAYAPA',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'DALAGUISEN',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'LAANG',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'LAGBEN',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'LAGUIBEN',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'NAGTIPULAN',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'NAGTUPACAN',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'PAGANAO',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'PAWA',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'PRESENTAR',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'SAN-ISIDRO',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'TAGODTOD',
    },
    {
        CITY: 'LAGANGILANG',
        BARANGAY: 'TAPING',
    },
    {
        CITY: 'LAGAYAN',
        BARANGAY: 'BA-I',
    },
    {
        CITY: 'LAGAYAN',
        BARANGAY: 'COLLAGO',
    },
    {
        CITY: 'LAGAYAN',
        BARANGAY: 'PANG-OT',
    },
    {
        CITY: 'LAGAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LAGAYAN',
        BARANGAY: 'PULOT',
    },
    {
        CITY: 'LANGIDEN',
        BARANGAY: 'BAAC',
    },
    {
        CITY: 'LANGIDEN',
        BARANGAY: 'DALAYAP (NALAAS)',
    },
    {
        CITY: 'LANGIDEN',
        BARANGAY: 'MABUNGTOT',
    },
    {
        CITY: 'LANGIDEN',
        BARANGAY: 'MALAPAAO',
    },
    {
        CITY: 'LANGIDEN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LANGIDEN',
        BARANGAY: 'QUILLAT',
    },
    {
        CITY: 'LICUAN-BAAY',
        BARANGAY: 'BONGLO (PATAGUI)',
    },
    {
        CITY: 'LICUAN-BAAY',
        BARANGAY: 'BULBULALA',
    },
    {
        CITY: 'LICUAN-BAAY',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'LICUAN-BAAY',
        BARANGAY: 'DOMENGLAY',
    },
    {
        CITY: 'LICUAN-BAAY',
        BARANGAY: 'LENNENG',
    },
    {
        CITY: 'LICUAN-BAAY',
        BARANGAY: 'MAPISLA',
    },
    {
        CITY: 'LICUAN-BAAY',
        BARANGAY: 'MOGAO',
    },
    {
        CITY: 'LICUAN-BAAY',
        BARANGAY: 'NALBUAN',
    },
    {
        CITY: 'LICUAN-BAAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LICUAN-BAAY',
        BARANGAY: 'SUBAGAN',
    },
    {
        CITY: 'LICUAN-BAAY',
        BARANGAY: 'TUMALIP',
    },
    {
        CITY: 'LUBA',
        BARANGAY: 'AMPALIOC',
    },
    {
        CITY: 'LUBA',
        BARANGAY: 'BARIT',
    },
    {
        CITY: 'LUBA',
        BARANGAY: 'GAYAMAN',
    },
    {
        CITY: 'LUBA',
        BARANGAY: 'LUL-LUNO',
    },
    {
        CITY: 'LUBA',
        BARANGAY: 'LUZONG',
    },
    {
        CITY: 'LUBA',
        BARANGAY: 'NAGBUKEL-TUQUIPA',
    },
    {
        CITY: 'LUBA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LUBA',
        BARANGAY: 'SABNANGAN',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'BINASARAN',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'BUANAO',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'DULAO',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'DULDULAO',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'GACAB',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'LAT-EY',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'MALIBCONG',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'MALIBCONG (POB.)',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'MATARAGAN',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'PACGUED',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'TARIPAN',
    },
    {
        CITY: 'MALIBCONG',
        BARANGAY: 'UMNAP',
    },
    {
        CITY: 'MANABO',
        BARANGAY: 'AYYENG',
    },
    {
        CITY: 'MANABO',
        BARANGAY: 'AYYENG (POB.)',
    },
    {
        CITY: 'MANABO',
        BARANGAY: 'CATACDEGAN NUEVO',
    },
    {
        CITY: 'MANABO',
        BARANGAY: 'CATACDEGAN VIEJO',
    },
    {
        CITY: 'MANABO',
        BARANGAY: 'LUZONG',
    },
    {
        CITY: 'MANABO',
        BARANGAY: 'SAN JOSE NORTE',
    },
    {
        CITY: 'MANABO',
        BARANGAY: 'SAN JOSE SUR',
    },
    {
        CITY: 'MANABO',
        BARANGAY: 'SAN-JUAN NORTE',
    },
    {
        CITY: 'MANABO',
        BARANGAY: 'SAN-JUAN SUR',
    },
    {
        CITY: 'MANABO',
        BARANGAY: 'SAN RAMON EAST',
    },
    {
        CITY: 'MANABO',
        BARANGAY: 'SAN RAMON WEST',
    },
    {
        CITY: 'MANABO',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'PENARRUBIA',
        BARANGAY: 'DUMAYCO',
    },
    {
        CITY: 'PENARRUBIA',
        BARANGAY: 'LUSUAC',
    },
    {
        CITY: 'PENARRUBIA',
        BARANGAY: 'MALAMSIT',
    },
    {
        CITY: 'PENARRUBIA',
        BARANGAY: 'MALAMSIT (PAU-MALAMSIT)',
    },
    {
        CITY: 'PENARRUBIA',
        BARANGAY: 'NAMARABAR',
    },
    {
        CITY: 'PENARRUBIA',
        BARANGAY: 'PATIAO',
    },
    {
        CITY: 'PENARRUBIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PENARRUBIA',
        BARANGAY: 'RIANG (TIANG)',
    },
    {
        CITY: 'PENARRUBIA',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'PENARRUBIA',
        BARANGAY: 'TATTAWA',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'ALINAYA',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'ARAB',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'GARRETA',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'IMMULI',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'LASKIG',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'MONGGOC',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'NAGUIRAYAN',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'PAMUTIC',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'PANGTUD',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'SAN DIEGO',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'SULBEC',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'SUYO (MALIDONG)',
    },
    {
        CITY: 'PIDIGAN',
        BARANGAY: 'YUYENG',
    },
    {
        CITY: 'SALLAPADAN',
        BARANGAY: 'BAZAR',
    },
    {
        CITY: 'SALLAPADAN',
        BARANGAY: 'BILABILA',
    },
    {
        CITY: 'SALLAPADAN',
        BARANGAY: 'GANGAL',
    },
    {
        CITY: 'SALLAPADAN',
        BARANGAY: 'GANGAL (POB.)',
    },
    {
        CITY: 'SALLAPADAN',
        BARANGAY: 'MAGUYEPYEP',
    },
    {
        CITY: 'SALLAPADAN',
        BARANGAY: 'NAGUILIAN',
    },
    {
        CITY: 'SALLAPADAN',
        BARANGAY: 'SACCAANG',
    },
    {
        CITY: 'SALLAPADAN',
        BARANGAY: 'SALLAPADAN',
    },
    {
        CITY: 'SALLAPADAN',
        BARANGAY: 'SUBUSOB',
    },
    {
        CITY: 'SALLAPADAN',
        BARANGAY: 'UD-UDIAO',
    },
    {
        CITY: 'TAYUM',
        BARANGAY: 'BAGALAY',
    },
    {
        CITY: 'TAYUM',
        BARANGAY: 'BASBASA',
    },
    {
        CITY: 'TAYUM',
        BARANGAY: 'BUDAC',
    },
    {
        CITY: 'TAYUM',
        BARANGAY: 'BUMAGCAT',
    },
    {
        CITY: 'TAYUM',
        BARANGAY: 'CABAROAN',
    },
    {
        CITY: 'TAYUM',
        BARANGAY: 'DEET',
    },
    {
        CITY: 'TAYUM',
        BARANGAY: 'GADDANI',
    },
    {
        CITY: 'TAYUM',
        BARANGAY: 'PATUCANNAY',
    },
    {
        CITY: 'TAYUM',
        BARANGAY: 'PIAS',
    },
    {
        CITY: 'TAYUM',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TAYUM',
        BARANGAY: 'VELASCO',
    },
    {
        CITY: 'TINEG',
        BARANGAY: 'AGSIMAO POBLACION',
    },
    {
        CITY: 'TINEG',
        BARANGAY: 'ALAOA',
    },
    {
        CITY: 'TINEG',
        BARANGAY: 'ANAYAN',
    },
    {
        CITY: 'TINEG',
        BARANGAY: 'APAO',
    },
    {
        CITY: 'TINEG',
        BARANGAY: 'BELAAT',
    },
    {
        CITY: 'TINEG',
        BARANGAY: 'CAGANAYAN',
    },
    {
        CITY: 'TINEG',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'TINEG',
        BARANGAY: 'LANEC',
    },
    {
        CITY: 'TINEG',
        BARANGAY: 'LAPAT-BALANTAY',
    },
    {
        CITY: 'TINEG',
        BARANGAY: 'NAGLIBACAN',
    },
    {
        CITY: 'TINEG',
        BARANGAY: 'POBLACION (AGSIMAO)',
    },
    {
        CITY: 'TUBO',
        BARANGAY: 'ALANGTIN',
    },
    {
        CITY: 'TUBO',
        BARANGAY: 'AMTUAGAN',
    },
    {
        CITY: 'TUBO',
        BARANGAY: 'DILONG',
    },
    {
        CITY: 'TUBO',
        BARANGAY: 'KILI',
    },
    {
        CITY: 'TUBO',
        BARANGAY: 'MAYABO POBLACION',
    },
    {
        CITY: 'TUBO',
        BARANGAY: 'POBLACION (MAYABO)',
    },
    {
        CITY: 'TUBO',
        BARANGAY: 'SUPO',
    },
    {
        CITY: 'TUBO',
        BARANGAY: 'TABACDA',
    },
    {
        CITY: 'TUBO',
        BARANGAY: 'TIEMPO',
    },
    {
        CITY: 'TUBO',
        BARANGAY: 'TUBTUBA',
    },
    {
        CITY: 'TUBO',
        BARANGAY: 'WAYANGAN',
    },
    {
        CITY: 'VILLAVICIOSA',
        BARANGAY: 'AP-APAYA',
    },
    {
        CITY: 'VILLAVICIOSA',
        BARANGAY: 'BOL-LILISING',
    },
    {
        CITY: 'VILLAVICIOSA',
        BARANGAY: 'CAL-LAO',
    },
    {
        CITY: 'VILLAVICIOSA',
        BARANGAY: 'LAP-LAPOG',
    },
    {
        CITY: 'VILLAVICIOSA',
        BARANGAY: 'LUMABA',
    },
    {
        CITY: 'VILLAVICIOSA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'VILLAVICIOSA',
        BARANGAY: 'TAMAC',
    },
    {
        CITY: 'VILLAVICIOSA',
        BARANGAY: 'TUQUIB',
    },
    {
        CITY: 'AGUINALDO',
        BARANGAY: 'BUNHIAN',
    },
    {
        CITY: 'AGUINALDO',
        BARANGAY: 'BUWAG',
    },
    {
        CITY: 'AGUINALDO',
        BARANGAY: 'GALONOGON',
    },
    {
        CITY: 'AGUINALDO',
        BARANGAY: 'ITAB',
    },
    {
        CITY: 'AGUINALDO',
        BARANGAY: 'JACMAL',
    },
    {
        CITY: 'AGUINALDO',
        BARANGAY: 'POSNAAN',
    },
    {
        CITY: 'AGUINALDO',
        BARANGAY: 'TA-ANG',
    },
    {
        CITY: 'AGUINALDO',
        BARANGAY: 'TALITE',
    },
    {
        CITY: 'AGUINALDO',
        BARANGAY: 'UBAO',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'BANGAR',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'BUSILAC',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'CALIMAG',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'CALUPAAN',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'CARAGASAN',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'DOLOWOG',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'KILING',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'LAYA',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'LITTLE TADIAN',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'NAMILLANGAN',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'NAMNAMA',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'NGILEB',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'PINTO',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'SAN-JUAN',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'SAN-QUINTIN',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'ALFONSO-LISTA',
        BARANGAY: 'SANTO DOMINGO (CABICALAN)',
    },
    {
        CITY: 'ASIPULO',
        BARANGAY: 'AMDUNTOG',
    },
    {
        CITY: 'ASIPULO',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'ASIPULO',
        BARANGAY: 'CAMANDAG',
    },
    {
        CITY: 'ASIPULO',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'ASIPULO',
        BARANGAY: 'HALLAP',
    },
    {
        CITY: 'ASIPULO',
        BARANGAY: 'LIWON',
    },
    {
        CITY: 'ASIPULO',
        BARANGAY: 'NAMAL',
    },
    {
        CITY: 'ASIPULO',
        BARANGAY: 'NUNGAWA',
    },
    {
        CITY: 'ASIPULO',
        BARANGAY: 'PANUBTUBAN',
    },
    {
        CITY: 'ASIPULO',
        BARANGAY: 'PULA',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'AMGANAD',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'ANABA',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'BALAWIS',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'BANAO',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'BANGAAN',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'BATAD',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'BOCOS',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'CAMBULO',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'DUCLIGAN',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'GOHANG',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'KINAKIN',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'OHAJ',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'POITAN',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'PULA',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'TAM-AN',
    },
    {
        CITY: 'BANAUE',
        BARANGAY: 'VIEW POINT',
    },
    {
        CITY: 'HINGYON',
        BARANGAY: 'ANAO',
    },
    {
        CITY: 'HINGYON',
        BARANGAY: 'BANGTINON',
    },
    {
        CITY: 'HINGYON',
        BARANGAY: 'BITU',
    },
    {
        CITY: 'HINGYON',
        BARANGAY: 'CABABUYAN',
    },
    {
        CITY: 'HINGYON',
        BARANGAY: 'MOMPOLIA',
    },
    {
        CITY: 'HINGYON',
        BARANGAY: 'NAMULDITAN',
    },
    {
        CITY: 'HINGYON',
        BARANGAY: 'NORTHERN CABABUYAN',
    },
    {
        CITY: 'HINGYON',
        BARANGAY: 'O-ONG',
    },
    {
        CITY: 'HINGYON',
        BARANGAY: 'PIWONG',
    },
    {
        CITY: 'HINGYON',
        BARANGAY: 'POBLACION (HINGYON)',
    },
    {
        CITY: 'HINGYON',
        BARANGAY: 'UBUAG',
    },
    {
        CITY: 'HINGYON',
        BARANGAY: 'UMALBONG',
    },
    {
        CITY: 'HUNGDUAN',
        BARANGAY: 'ABATAN',
    },
    {
        CITY: 'HUNGDUAN',
        BARANGAY: 'BA-ANG',
    },
    {
        CITY: 'HUNGDUAN',
        BARANGAY: 'BANGBANG',
    },
    {
        CITY: 'HUNGDUAN',
        BARANGAY: 'BOKIAWAN',
    },
    {
        CITY: 'HUNGDUAN',
        BARANGAY: 'HAPAO',
    },
    {
        CITY: 'HUNGDUAN',
        BARANGAY: 'LUBO-ONG',
    },
    {
        CITY: 'HUNGDUAN',
        BARANGAY: 'MAGGOK',
    },
    {
        CITY: 'HUNGDUAN',
        BARANGAY: 'NUNGULUNAN',
    },
    {
        CITY: 'HUNGDUAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'AMBABAG',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'BAGUINGE',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'BOKIAWAN',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'BOLOG',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'DALLIGAN',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'DUIT',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'HUCAB',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'JULONGAN',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'LINGAY',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'MUNGAYANG',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'NAGACADAN',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'PINDONGAN',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KIANGAN',
        BARANGAY: 'TUPLAC',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'ABINUAN',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'BANGA',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'BOLIWONG',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'BURNAY',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'BUYABUYAN',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'CABA',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'CUDOG',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'DULAO',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'JUCBONG',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'LUTA',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'MONTABIONG',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'OLILICON',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'PONGHAL',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'PULLAAN',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'TUNGNGOD',
    },
    {
        CITY: 'LAGAWE',
        BARANGAY: 'TUPAYA',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'AMBASA',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'BIMPAL',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'HAPID',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'HOLOWON',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'LAWIG',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'LUCBAN',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'MABATOBATO (LAMUT)',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'MAGULON',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'NAYON',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'PANOPDOPAN',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'PAYAWAN',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'PIEZA',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'PUGOL (IFUGAO RESERVATION)',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'SALAMAGUE',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'SANAFE',
    },
    {
        CITY: 'LAMUT',
        BARANGAY: 'UMILAG',
    },
    {
        CITY: 'TINOC',
        BARANGAY: 'AHIN',
    },
    {
        CITY: 'TINOC',
        BARANGAY: 'AP-APID',
    },
    {
        CITY: 'TINOC',
        BARANGAY: 'BINABLAYAN',
    },
    {
        CITY: 'TINOC',
        BARANGAY: 'DANGGO',
    },
    {
        CITY: 'TINOC',
        BARANGAY: 'EHEB',
    },
    {
        CITY: 'TINOC',
        BARANGAY: 'GUMHANG',
    },
    {
        CITY: 'TINOC',
        BARANGAY: 'IMPUGONG',
    },
    {
        CITY: 'TINOC',
        BARANGAY: 'LUHONG',
    },
    {
        CITY: 'TINOC',
        BARANGAY: 'TINOC',
    },
    {
        CITY: 'TINOC',
        BARANGAY: 'TUKUCAN',
    },
    {
        CITY: 'TINOC',
        BARANGAY: 'TULLUDAN',
    },
    {
        CITY: 'TINOC',
        BARANGAY: 'WANGWANG',
    },
    {
        CITY: 'ATOK',
        BARANGAY: 'ABIANG',
    },
    {
        CITY: 'ATOK',
        BARANGAY: 'CALIKING',
    },
    {
        CITY: 'ATOK',
        BARANGAY: 'CATTUBO',
    },
    {
        CITY: 'ATOK',
        BARANGAY: 'NAGUEY',
    },
    {
        CITY: 'ATOK',
        BARANGAY: 'PAOAY',
    },
    {
        CITY: 'ATOK',
        BARANGAY: 'PASDONG',
    },
    {
        CITY: 'ATOK',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ATOK',
        BARANGAY: 'TOPDAC',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'A. BONIFACIO-CAGUIOA-RIMANDO (ABCR)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'A. BONIFACIO-CAGUIOA-RIMANDO (ABCR)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'ABANAO-ZANDUETA-KAYONG-CHUGUM-OTEK (AZKCO)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'ALFONSO TABORA',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'AMBIONG',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'ANDRES BONIFACIO (LOWER BOKAWKAN)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'APUGAN-LOAKAN',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'ASIN ROAD',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'ATOK TRAIL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'AURORA HILL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'AURORA HILL NORTH CENTRAL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'AURORA HILL PROPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'AURORA HILL PROPER (MALVAR-SGT. FLORESCA)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'AURORA HILL SOUTH CENTRAL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BAGONG LIPUNAN (MARKET AREA)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BAKAKENG CENTRAL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BAKAKENG CENTRAL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BAKAKENG NORTH',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BAL-MARCOVILLE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BAL-MARCOVILLE (MARCOVILLE)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BALSIGAN',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BAYAN PARK EAST',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BAYAN PARK VILLAGE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BAYAN PARK WEST (BAYAN PARK)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BGH COMPOUND',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BROOKSIDE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'BROOKSPOINT',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'CABINET HILL-TEACHER\'S CAMP',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'CAMDAS SUBDIVISION',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'CAMP 7',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'CAMP 7',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'CAMP 8',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'CAMP ALLEN',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'CAMPO FILIPINO',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'CITY CAMP CENTRAL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'CITY CAMP PROPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'COUNTRY CLUB VILLAGE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'CRESENCIA VILLAGE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'DAGSIAN',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'DAGSIAN LOWER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'DAGSIAN UPPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'DIZON SUBDIVISION',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'DOMINICAN HILL-MIRADOR',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'DONTOGAN',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'DPS AREA',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'ENGINEERS HILL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'ENGINEERS\' HILL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'ENGINEER\'S HILL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'FAIRVIEW VILLAGE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'FERDINAND (HAPPY HOMES-CAMPO SIOCO)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'FORT DEL PILAR',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'GABRIELA SILANG',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'GENERAL EMILIO F. AGUINALDO',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'GENERAL EMILIO F. AGUINALDO (QUIRINO-MAGSAYSAY LOWER)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'GENERAL LUNA LOWER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'GENERAL LUNA UPPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'GIBRALTAR',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'GREENWATER VILLAGE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'GUISAD CENTRAL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'GUISAD SORONG',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'HAPPY HOLLOW',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'HAPPY HOMES (HAPPY HOMES-LUCBAN)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'HARRISON-CLAUDIO CARANTES',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'HILLSIDE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'HOLY GHOST EXTENSION',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'HOLY GHOST PROPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'HONEYMOON (HONEYMOON-HOLY GHOST)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'IMELDA R. MARCOS (LA SALLE)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'IMELDA VILLAGE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'IRISAN',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'KABAYANIHAN',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'KAGITINGAN',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'KAYANG EXTENSION',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'KAYANG-HILLTOP',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'KIAS',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'LEGARDA-BURNHAM-KISAD',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'LIWANAG-LOAKAN',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'LOAKAN PROPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'LOPEZ JAENA',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'LOURDES SUBDIVISION',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'LOURDES SUBDIVISION EXTENSION',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'LOURDES SUBDIVISION LOWER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'LOURDES SUBDIVISION PROPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'LOURDES SUBDIVISION, LOWER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'LOURDES SUBDIVISION, PROPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'LUALHATI',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'LUCNAB',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MAGSAYSAY LOWER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MAGSAYSAY PRIVATE ROAD',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MAGSAYSAY UPPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MALCOLM SQUARE-PERFECTO (JOSE ABAD SANTOS)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MANUEL A. ROXAS',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MARKET SUBDIVISION',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MARKET SUBDIVISION UPPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MIDDLE QUEZON HILL SUBDIVISION(QUEZON HILL MIDDLE)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MILITARY CUT-OFF',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MINES VIEW PARK',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MODERN SITE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MODERN SITE EAST',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MODERN SITE WEST',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'MRR-QUEEN OF PEACE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'NEW LUCBAN',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'OUTLOOK DRIVE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'PACDAL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'PADRE BURGOS',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'PADRE ZAMORA',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'PALMA-URBANO (CARINO-PALMA)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'PHIL-AM',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'PINGET',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'PINSAO PILOT PROJECT',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'PINSAO PROPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'POLIWES',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'PUCSUSAN',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'QUEZON HILL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'QUEZON HILL PROPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'QUEZON HILL UPPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'QUIRINO HILL',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'QUIRINO HILL EAST',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'QUIRINO HILL LOWER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'QUIRINO HILL MIDDLE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'QUIRINO HILL WEST',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'QUIRINO-MAGSAYSAY',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'QUIRINO-MAGSAYSAY UPPER (UPPER QM)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'RIZAL MONUMENT AREA',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'ROCK QUARRY',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'ROCK QUARRY LOWER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'ROCK QUARRY MIDDLE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'ROCK QUARRY UPPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SAINT JOSEPH VILLAGE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SALUD MITRA',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SAN ANTONIO VILLAGE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SAN LUIS VILLAGE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SAN ROQUE VILLAGE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SANITARY CAMP',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SANITARY CAMP NORTH',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SANITARY CAMP SOUTH',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SANTA ESCOLASTICA',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SANTO TOMAS PROPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SANTO TOMAS PROPER',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SANTO TOMAS SCHOOL AREA',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SCOUT BARRIO',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SESSION ROAD AREA',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SLAUGHTER HOUSE AREA (SANTO NINO SLAUGHTER)',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SLU-SVP HOUSING VILLAGE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'SOUTH DRIVE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'TEODORA ALONZO',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'TRANCOVILLE',
    },
    {
        CITY: 'BAGUIO',
        BARANGAY: 'VICTORIA VILLAGE',
    },
    {
        CITY: 'BAKUN',
        BARANGAY: 'AMPUSONGAN',
    },
    {
        CITY: 'BAKUN',
        BARANGAY: 'BAGU',
    },
    {
        CITY: 'BAKUN',
        BARANGAY: 'DALIPEY',
    },
    {
        CITY: 'BAKUN',
        BARANGAY: 'GAMBANG',
    },
    {
        CITY: 'BAKUN',
        BARANGAY: 'KAYAPA',
    },
    {
        CITY: 'BAKUN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BAKUN',
        BARANGAY: 'POBLACION (CENTRAL)',
    },
    {
        CITY: 'BAKUN',
        BARANGAY: 'SINACBAT',
    },
    {
        CITY: 'BOKOD',
        BARANGAY: 'AMBUCLAO',
    },
    {
        CITY: 'BOKOD',
        BARANGAY: 'BILA',
    },
    {
        CITY: 'BOKOD',
        BARANGAY: 'BOBOK-BISAL',
    },
    {
        CITY: 'BOKOD',
        BARANGAY: 'DACLAN',
    },
    {
        CITY: 'BOKOD',
        BARANGAY: 'EKIP',
    },
    {
        CITY: 'BOKOD',
        BARANGAY: 'KARAO',
    },
    {
        CITY: 'BOKOD',
        BARANGAY: 'NAWAL',
    },
    {
        CITY: 'BOKOD',
        BARANGAY: 'PITO',
    },
    {
        CITY: 'BOKOD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BOKOD',
        BARANGAY: 'TIKEY',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'ABATAN',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'AMGALEYGUEY',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'AMLIMAY',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'BACULONGAN NORTE',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'BACULONGAN SUR',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'BANGAO',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'BUYACAOAN',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'CALAMAGAN',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'CATLUBONG',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'LENGAOAN',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'LOO',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'NATUBLENG',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'POBLACION (CENTRAL)',
    },
    {
        CITY: 'BUGUIAS',
        BARANGAY: 'SEBANG',
    },
    {
        CITY: 'ITOGON',
        BARANGAY: 'AMPUCAO',
    },
    {
        CITY: 'ITOGON',
        BARANGAY: 'DALUPIRIP',
    },
    {
        CITY: 'ITOGON',
        BARANGAY: 'GUMATDANG',
    },
    {
        CITY: 'ITOGON',
        BARANGAY: 'LOACAN',
    },
    {
        CITY: 'ITOGON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ITOGON',
        BARANGAY: 'POBLACION (CENTRAL)',
    },
    {
        CITY: 'ITOGON',
        BARANGAY: 'TINONGDAN',
    },
    {
        CITY: 'ITOGON',
        BARANGAY: 'TUDING',
    },
    {
        CITY: 'ITOGON',
        BARANGAY: 'UCAB',
    },
    {
        CITY: 'ITOGON',
        BARANGAY: 'VIRAC',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'ADAOAY',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'ANCHUKEY',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'BALLAY',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'BASHOY',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'BATAN',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'DUACAN',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'EDDET',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'GUSARAN',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'KABAYAN BARRIO',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'LUSOD',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'PACSO',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'POBLACION (CENTRAL)',
    },
    {
        CITY: 'KABAYAN',
        BARANGAY: 'TAWANGAN',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'BALAKBAK',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'BELENG-BELIS',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'BOKLAOAN',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'CAYAPES',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'CUBA',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'DATAKAN',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'GADANG',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'GASWELING',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'LABUEG',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'PAYKEK',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'POBLACION CENTRAL',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'PONGAYAN',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'PUDONG',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'SAGUBO',
    },
    {
        CITY: 'KAPANGAN',
        BARANGAY: 'TABA-AO',
    },
    {
        CITY: 'KIBUNGAN',
        BARANGAY: 'BADEO',
    },
    {
        CITY: 'KIBUNGAN',
        BARANGAY: 'LUBO',
    },
    {
        CITY: 'KIBUNGAN',
        BARANGAY: 'MADAYMEN',
    },
    {
        CITY: 'KIBUNGAN',
        BARANGAY: 'PALINA',
    },
    {
        CITY: 'KIBUNGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KIBUNGAN',
        BARANGAY: 'SAGPAT',
    },
    {
        CITY: 'KIBUNGAN',
        BARANGAY: 'TACADANG',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'ALAPANG',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'ALNO',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'AMBIONG',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'BAHONG',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'BALILI',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'BECKEL',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'BETAG',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'BINENG',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'CRUZ',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'LUBAS',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'PICO',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'PUGUIS',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'SHILAN',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'TAWANG',
    },
    {
        CITY: 'LA-TRINIDAD',
        BARANGAY: 'WANGAL',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'BALILI',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'BALILI',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'BEDBED',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'BULALACAO',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'CABITEN',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'COLALO',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'GUINAOANG',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'PACO',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'PALASAAN',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'SAPID',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'TABIO',
    },
    {
        CITY: 'MANKAYAN',
        BARANGAY: 'TANEG',
    },
    {
        CITY: 'SABLAN',
        BARANGAY: 'BAGONG',
    },
    {
        CITY: 'SABLAN',
        BARANGAY: 'BALLUAY',
    },
    {
        CITY: 'SABLAN',
        BARANGAY: 'BANANGAN',
    },
    {
        CITY: 'SABLAN',
        BARANGAY: 'BANENGBENG',
    },
    {
        CITY: 'SABLAN',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'SABLAN',
        BARANGAY: 'KAMOG',
    },
    {
        CITY: 'SABLAN',
        BARANGAY: 'PAPPA',
    },
    {
        CITY: 'SABLAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'ANSAGAN',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'CAMP 3',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'CAMP 4',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'CAMP ONE',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'NANGALISAN',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'TABAAN NORTE',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'TABAAN SUR',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'TADIANGAN',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'TALOY NORTE',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'TALOY SUR',
    },
    {
        CITY: 'TUBA',
        BARANGAY: 'TWIN PEAKS',
    },
    {
        CITY: 'TUBLAY',
        BARANGAY: 'AMBASSADOR',
    },
    {
        CITY: 'TUBLAY',
        BARANGAY: 'AMBONGDOLAN',
    },
    {
        CITY: 'TUBLAY',
        BARANGAY: 'BA-AYAN',
    },
    {
        CITY: 'TUBLAY',
        BARANGAY: 'BASIL',
    },
    {
        CITY: 'TUBLAY',
        BARANGAY: 'CAPONGA (POB.)',
    },
    {
        CITY: 'TUBLAY',
        BARANGAY: 'CAPONGA POBLACION',
    },
    {
        CITY: 'TUBLAY',
        BARANGAY: 'DACLAN',
    },
    {
        CITY: 'TUBLAY',
        BARANGAY: 'TUBLAY CENTRAL',
    },
    {
        CITY: 'TUBLAY',
        BARANGAY: 'TUEL',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'ABATAN',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'BAGNEN ORIENTE',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'BAGNEN PROPER',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'BALINTAUGAN',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'BANAO',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'BILA (BUA)',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'GUINZADAN CENTRAL',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'GUINZADAN NORTE',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'GUINZADAN SUR',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'LAGAWA',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'LESEB',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'MABAAY',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'MAYAG',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'MONAMON NORTE',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'MONAMON SUR',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'MOUNT DATA',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'OTUCAN NORTE',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'OTUCAN SUR',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'POBLACION (BAUKO)',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'SADSADAN',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'SINTO',
    },
    {
        CITY: 'BAUKO',
        BARANGAY: 'TAPAPAN',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'AGAWA',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'AMBAGUIO',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'BANGUITAN',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'BESAO EAST (BESAO PROPER)',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'BESAO WEST',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'CATENGAN',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'GUEDAY',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'KIN-IWAY (POB.)',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'LACMAAN',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'LAYLAYA',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'PADANGAN',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'PAYEO',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'SUQUIB',
    },
    {
        CITY: 'BESAO',
        BARANGAY: 'TAMBOAN',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'ALAB ORIENTE',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'ALAB PROPER',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'BALILI',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'BAYYO',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'BONTOC ILI',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'CALUTIT',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'CANEO',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'DALICAN',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'GONOGON',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'GUINAANG',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'MALIGCONG',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'POBLACION (BONTOC)',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'SAMOKI',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'TALUBIN',
    },
    {
        CITY: 'Bontoc',
        BARANGAY: 'TOCUCAN',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'BAO-ANGAN',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'BUN-AYAN',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'BUSA',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'CAMATAGAN',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'CAPINITAN',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'DATA',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'GAYANG',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'LAGAN',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'LOSAD',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'NAMATEC',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'NAPUA',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'PINGAD',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'SUPANG',
    },
    {
        CITY: 'SABANGAN',
        BARANGAY: 'TAMBINGAN',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'AGUID',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'AMBASING',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'ANGKELING',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'ANTADAO',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'BALUGAN',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'BANGAAN',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'DAGDAG (POB.)',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'DEMANG (POB.)',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'FIDELISAN',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'KILONG',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'MADONGO',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'NACAGANG',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'PIDE',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'POBLACION (PATAY)',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'SUYO',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'TACCONG',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'TANULONG',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'TETEPAN NORTE',
    },
    {
        CITY: 'SAGADA',
        BARANGAY: 'TETEPAN SUR',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'BALAOA',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'BANAAO',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'BANTEY',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'BATAYAN',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'CADAD-ANAN',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'CAGUBATAN',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'DACUDAC',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'DUAGAN',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'KAYAN EAST',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'KAYAN WEST',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'LENGA',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'LUBON',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'MABALITE',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'MASLA',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'PANDAYAN',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'SUMADEL',
    },
    {
        CITY: 'TADIAN',
        BARANGAY: 'TUE',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'BACSAY',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CAGANDUNGAN',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CALABIGAN',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CANGISITAN',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CAPAGAYPAYAN',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'LAPPA',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'LUYON',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'MARAG',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'QUIRINO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SAN-ISIDRO NORTE',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SAN-ISIDRO SUR',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SANTA LINA',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SHALOM',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'TUMOG',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'TUROD',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'ZUMIGUI',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'BUTAO',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'CADACLAN',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'DON ROQUE ABLAN SR.',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'ELEAZAR',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'EVA PUZON',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'KABUGAWAN',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'LANGNAO',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'LUBONG',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'MACALINO',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'NAGUILIAN',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'NAMALTUGAN',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'SABANGAN',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'TANGLAGAN',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'TUBANG',
    },
    {
        CITY: 'CALANASAN',
        BARANGAY: 'TUBONGAN',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'ALLANGIGAN',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'BULUAN',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'CAGLAYAN',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'CAGLAYAN (NEW POB.)',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'CALAFUG',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'CUPIS',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'DAGA',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'GUINAANG',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'GUINAMGAMAN',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'ILI',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'KARIKITAN',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'KATABLANGAN',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'MALAMA',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'MANAG',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'MAWEGUI',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'NABUANGAN',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'PADDAOAN',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'PUGUIN',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'RIPANG',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'RIPANG (OLD POB.)',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'SACPIL',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CONNER',
        BARANGAY: 'TALIFUGO',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'ALLIG',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'ANNINIPAN',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'ATOK',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'BAGUTONG',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'BALASI',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'BALLUYAN',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'MALAYUGAN',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'MALLIG',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'MALUBIBIT NORTE',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'MALUBIBIT SUR',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'TAMALUNOG',
    },
    {
        CITY: 'FLORA',
        BARANGAY: 'UPPER ATOK (COLIMAN)',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'BADDUAT',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'BALIWANAN',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'BULU',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'CABETAYAN',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'DAGARA',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'DIBAGAT',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'KARAGAWAN',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'KUMAO',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'LACO',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'LENNENG (LIYYENG)',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'LUCAB',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'LUTTUACAN',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'MADATAG',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'MADDUANG',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'MAGABTA',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'MARAGAT',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'MUSIMUT',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'NAGBABALAYAN',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'TUYANGAN',
    },
    {
        CITY: 'KABUGAO',
        BARANGAY: 'WAGA',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'AGA',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'ALEM',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'AMADO',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'CABATACAN',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'CACALAGGAN',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'CAPANNIKIAN',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'DONA LORETA',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'EMILIA',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'LOWER MATON',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'LT. BALAG',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'LT. BILAG',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'LYDIA',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'MALIBANG',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'MATAGUISI',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'SAN ANTONIO (PUGO)',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'SAN MARIANO',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'SWAN',
    },
    {
        CITY: 'PUDTOL',
        BARANGAY: 'UPPER MATON',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'BAROCBOC',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'CONSUELO',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'EMILIANA',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'IMELDA (SIPA ANNEX)',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'MALEKKEG',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'MARCELA (POB.)',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'MARCELA POBLACION',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'NUEVA',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'PANAY',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'SAN-JUAN',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'SAN MARIANO',
    },
    {
        CITY: 'SANTA-MARCELA',
        BARANGAY: 'SIPA PROPER',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'BIANUAN',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'CALABGAN',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'CALANGCUASAN',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'CALANTAS',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'CULAT',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'DIBACONG',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'DIBET',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'DITINAGYAN',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'ESTEVES',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'LUAL',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'MARIKIT',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'TABAS',
    },
    {
        CITY: 'AURORA-CASIGURAN',
        BARANGAY: 'TINIB',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'DIBALO',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'DITEKI',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'DITUMABO',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'L. PIMENTEL',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'NONONG SENIOR',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'REAL',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'SAN-ISIDRO',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'AURORA-SAN-LUIS',
        BARANGAY: 'ZARAH',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'BUHANGIN',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'CALABUANAN',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'OBLIGACION',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'PINGIT',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'RESERVA',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'SUCLAYIN',
    },
    {
        CITY: 'BALER',
        BARANGAY: 'ZABALI',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DIAGYAN',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DICABASAN',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DILAGUIDI',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DIMASESET',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'DINIOG',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'MALIGAYA (POB.)',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'MANGGITAHAN',
    },
    {
        CITY: 'DILASAG',
        BARANGAY: 'MASAGANA (POB.)',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'ABULEG',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'DIBARAYBAY',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'DITAWINI',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'MAPALAD',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'NIPOO (BULO)',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'PALEG',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'SIMBAHAN',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'DINALUNGAN',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'APLAYA',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'BUTAS NA BATO',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'CABOG (MATAWE)',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'CARAGSACAN',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'DAVILDAVILAN',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'DIKAPANIKIAN',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'IBONA',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'PALTIC',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'TANAWAN',
    },
    {
        CITY: 'DINGALAN',
        BARANGAY: 'UMIRAY (MALAMIG)',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'BORLONGAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIAMANEN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIANED',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIARABASIN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIBUTUNAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DIMABUNO',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DINADIAWAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'DITALE',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'GUPA',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'LABOY',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'LIPIT',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'LOBBOT',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'MIJARES',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'MUCDOL',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'PUANGI',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'SALAY',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'SAPANGKAWAYAN',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'DIPACULAO',
        BARANGAY: 'TOYTOYAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'ALCALA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BAGTU',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BANGCO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BANNAWAG',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BAUBO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BAYANIHAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'BAZAL',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'CABITUCULAN EAST',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'CABITUCULAN WEST',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'CADAYACAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DEBUCAO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DETAILEN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIAAT',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIALATMAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIANAWAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIKILDIT',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIMANPUDSO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'DIOME',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'ESTONILO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'FLORIDA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'GALINTUJA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'QUIRINO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'RAMADA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SAN-JUAN',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SAN LEONARDO',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'SUGUIT',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'VILLA AURORA',
    },
    {
        CITY: 'MARIA-AURORA',
        BARANGAY: 'WENCESLAO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'BABALAG EAST (POB.)',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'BABALAG WEST (POB.)',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'BULBOL',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'LIWAN EAST',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'LIWAN WEST',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'MACUTAY',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'ROMUALDEZ',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SANTOR',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'ACIGA',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'ALLAGUIA',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'APATAN',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'ASIBANGLAN',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'BA-AY',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'BALLAYANGON',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'BAYAO',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'CAMALOG',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'CAWAGAYAN',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'KATABBOGAN',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'LIMOS',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'MAGAOGAO',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'MAPACO',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'PAKAWIT',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'PINUKPUK JUNCTION',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'SOCBOT',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'TAGA (POB.)',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'TAGGAY',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'WAGUD',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'AGBANNAWAG',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'AMLAO',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'APPAS',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'BADO DANGWA',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'BALAWAG',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'BALONG',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'BANTAY',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'BULANAO',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'BULANAO',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'BULANAO NORTE',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'BULO',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'CABARITAN',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'CALACCAD',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'CALANAN',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'CASIGAYAN',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'CUDAL',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'DAGUPAN CENTRO (POB.)',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'DAGUPAN WESTE',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'DILAG',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'DUPAG',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'GOBGOB',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'GUILAYON',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'LACNOG',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'LANNA',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'LAYA EAST',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'LAYA WEST',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'LUCOG',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'MAGNAO',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'MALIN-AWA',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'MASABLANG',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'NAMBARAN',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'NAMBUCAYAN',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'NANENG',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'NEW TANGLAG',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'SAN-JUAN',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'SAN JULIAN',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'SUYANG',
    },
    {
        CITY: 'TABUK',
        BARANGAY: 'TUGA',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'ANGGACAN',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'ANGGACAN SUR',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'BABBANOY',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'DACALAN',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'DUPLIGAN',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'GAANG',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'LAY-ASAN',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'LOWER LUBO',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'LOWER MANGALI',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'LOWER TALOCTOC',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'MABACA',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'MABACA',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'MANGALI CENTRO',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'PANGOL',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'POBLACION',
    }
];
